import { render, staticRenderFns } from "./PostsComponent.vue?vue&type=template&id=0116746a"
import script from "./PostsComponent.vue?vue&type=script&lang=js"
export * from "./PostsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0116746a')) {
      api.createRecord('0116746a', component.options)
    } else {
      api.reload('0116746a', component.options)
    }
    module.hot.accept("./PostsComponent.vue?vue&type=template&id=0116746a", function () {
      api.rerender('0116746a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/PostsComponent.vue"
export default component.exports